import ACCESS, { Gates } from 'utils/Access'
const SETTINGS_PATH = '/settings/setup'

export const IntegrationIds = {
  SLACK: "slackBot",
  LINKEDIN:  "linkedin",
  DRIFT_CODE: 'drift-code',
  HUBSPOT: "hubspot",
  ZAPIER:  "zapier",
  DRIP: "drip",
  FULLSTORY:  "fullstory",
  HELP_CENTER: "knowledgebase",
  SALESFORCE: "salesforce",
  MARKETO: "marketo",
  DEMANDBASE: "demandbase",
  MADKUDU: "madkudu",
  VIDYARD: "vidyard",
  GOOGLE_ANALYTICS: "googleAnalytics",
  CLEARBIT: "clearbit",
  OUTREACH: "outreach",
  FACEBOOK: "facebookAnalytics",
  LEANDATA: "leandata",
  STRIPE: "stripe",
}

export const Integrations = [
  {
    id: IntegrationIds.SLACK,
    title: 'Slack',
    keywords: 'communication messaging chat',
    description: 'Manage conversations and reply right from Slack.',
    logoSrc: require('images/svg/slack-logo.svg'),
    path: `${SETTINGS_PATH}/slack`,
  },
  {
    id: IntegrationIds.LINKEDIN,
    title: 'LinkedIn Sales Navigator',
    keywords: 'networking sales contacts',
    description: 'View Market Insights and connect with contacts directly through LinkedIn.',
    requiredGates: ['HAS_LINKEDIN'],
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade',
    logoSrc: require('images/svg/linkedin_logo.svg'),
    path: `${SETTINGS_PATH}/linkedin`,
  },
  {
    id: IntegrationIds.DRIFT_CODE,
    title: 'Drift HTTP API',
    keywords: 'drift code install api contacts',
    description: 'Enrich your data or manage your contacts with our API',
    logoSrc: require('images/svg/js-install-icon.svg'),
    external: true,
    externalUrl: 'https://devdocs.drift.com/docs',
  },
  {
    id: IntegrationIds.HUBSPOT,
    title: 'HubSpot',
    keywords: 'crm contacts',
    description: 'Connect with HubSpot to sync your new contacts with Drift.',
    logoSrc: require('images/svg/hubspot-logo.svg'),
    requiredGates: ['hubspot_settings'],
    path: `${SETTINGS_PATH}/hubspot`,
    gatedUrl: 'https://help.drift.com/integrations/hubspot-integration',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.ZAPIER,
    title: 'Zapier',
    keywords: 'crm contacts',
    description: 'Integrate any app via Zapier',
    logoSrc: require('images/svg/zapier-logo.svg'),
    requiredGates: [Gates.PREMIUM, Gates.STANDARD_APRIL_2018],
    path: `${SETTINGS_PATH}/zapier`,
    gatedUrl: 'https://help.drift.com/integrations/zapier-integration',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.DRIP,
    title: 'Drip',
    keywords: 'crm contacts',
    description: 'See your Drip data in Drift, and your Drift data in Drip.',
    logoSrc: require('images/drip-logo.png'),
    requiredGates: [Gates.PREMIUM],
    path: `${SETTINGS_PATH}/drip`,
    gatedUrl: 'https://help.drift.com/integrations/drip-integration',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.FULLSTORY,
    title: 'FullStory',
    keywords: 'advanced tracking',
    description: 'See what your customers see and give them the help they need.',
    logoSrc: require('images/logos/fullstory-logo.svg'),
    requiredGates: [Gates.PREMIUM],
    path: `${SETTINGS_PATH}/fullstory`,
    gatedUrl: 'https://help.drift.com/integrations/fullstory',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.HELP_CENTER,
    title: 'Help Center',
    keywords: 'drift help knowledgebase help zendesk helpscout helpdocs',
    description: 'Pair your Help Center with Drift’s intelligent messaging',
    logoSrc: require('images/settings/knowledge-base-group.svg'),
    grandfathered: () => ACCESS.hasGates(Gates.KNOWLEDGE_BASE),
    detail: 'Learn More',
    path: `${SETTINGS_PATH}/knowledgebase`,
    gatedUrl: 'http://help.drift.com/integrations/knowledge-base-and-help-doc-integrations',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.SALESFORCE,
    title: 'Salesforce',
    keywords: 'crm contacts',
    description: 'Sync your Drift leads and conversations to Salesforce',
    logoSrc: require('images/svg/salesforce-logo.svg'),
    requiredGates: [Gates.PREMIUM_TEAM, Gates.TEAM_VIDEO_LICENSE],
    detail: 'Learn More',
    path: `${SETTINGS_PATH}/salesforce`,
    gatedUrl: 'https://help.drift.com/integrations/salesforce',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.MARKETO,
    title: 'Marketo V2',
    keywords: 'crm contacts leads',
    description: 'Sync your Drift data over to Marketo V2',
    logoSrc: require('images/logos/marketo-logo.png'),
    requiredGates: [Gates.MARKETO],
    path: `${SETTINGS_PATH}/marketo`,
    gatedUrl: 'https://gethelp.drift.com/hc/en-us/articles/360019503974-How-to-Connect-Drift-and-Marketo',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.DEMANDBASE,
    title: 'Demandbase',
    keywords: 'encrichment firmographic',
    description: 'Connect Demandbase to enrich your Drift lead data',
    logoSrc: require('images/logos/demandbase-logo.svg'),
    requiredGates: [Gates.DEMANDBASE],
    path: `${SETTINGS_PATH}/demandbase`,
    gatedUrl: 'https://help.drift.com/integrations/demandbase-integration',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.MADKUDU,
    title: 'MadKudu',
    keywords: 'encrichment firmographic',
    description: "Use MadKudu's predictive lead scoring to qualify leads",
    logoSrc: require('images/logos/madkudu-logo.svg'),
    requiredGates: [Gates.HAS_MADKUDU, 'has_madkudu'], // lower case has_madkudu access grandfathered in.
    path: `${SETTINGS_PATH}/madkudu`,
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.VIDYARD,
    title: 'Vidyard',
    keywords: 'communication video screenshare messaging',
    description: 'Send personalized videos in conversations with Vidyard',
    logoSrc: require('images/logos/vidyard-logo.svg'),
    path: `${SETTINGS_PATH}/vidyard`
  },
  {
    id: IntegrationIds.GOOGLE_ANALYTICS,
    title: 'Google Analytics',
    keywords: 'analytics tracking google',
    description: 'Easily add Drift data to your Google Analytics dashboard',
    logoSrc: require('images/logos/google-analytics-icon.svg'),
    path: `${SETTINGS_PATH}/googleAnalytics`
  },
  {
    id: IntegrationIds.CLEARBIT,
    title: 'Clearbit',
    keywords: 'encrichment reveal',
    description: 'Connect Clearbit to enrich your Drift lead data',
    logoSrc: require('images/logos/clearbit-logo.svg'),
    requiredGates: [Gates.CLEARBIT_SETTINGS],
    path: `${SETTINGS_PATH}/clearbit`,
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  },
  {
    id: IntegrationIds.OUTREACH,
    title: 'Outreach',
    keywords: 'sequences email',
    description: 'Have seamless conversations between Drift & Outreach',
    logoSrc: require('images/logos/outreach-logo.png'),
    path: `${SETTINGS_PATH}/outreach`,
    requiredGates: [Gates.OUTREACH],
    gatedUrl: 'https://help.drift.com/article/outreach-integration',
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade',
    incompleteInstallEndpoint: '/integrations/outreach/install_status/internal',
  },
  {
    id: IntegrationIds.FACEBOOK,
    title: 'Facebook Analytics',
    keywords: 'analytics tracking facebook',
    description: 'Measure traffic to your conversational landing pages',
    logoSrc: require('images/logos/facebook.svg'),
    path: `${SETTINGS_PATH}/facebookAnalytics`,
  },
  {
    id: IntegrationIds.LEANDATA,
    title: 'LeanData',
    keywords: 'routing routing routing',
    description: 'Assign leads to reps using your LeanData account.',
    logoSrc: require('images/logos/leandata.svg'),
    path: `${SETTINGS_PATH}/leandata`,
    requiredGates: [Gates.LEANDATA],
    renderGate: [Gates.LEANDATA],
    isGatedByPlan: true,
    upgradeRibbonText: 'Soon!',
  },
  {
    id: IntegrationIds.STRIPE,
    title: 'Stripe Payments',
    keywords: 'payment transaction stripe',
    description: 'Process payments during conversations with Stripe.',
    logoSrc: require('images/logos/stripe.png'),
    path: `${SETTINGS_PATH}/stripe`,
    requiredGates: [Gates.STRIPE],
    renderGate: [Gates.STRIPE],
    isGatedByPlan: true,
    upgradeRibbonText: 'Soon!',
  }
]

export const IntegrationCategories = {
  ALL: {
    label: 'All integrations',
    keywords: '',
  },
  INSTALLED_APPS: {
    label: 'Connected integrations',
    keywords: 'installed',
  },
  PARTNER_APPS: {
    label: 'Third party integrations',
    keywords: 'partner',
  },
  COMMUNICATION: {
    label: 'Communication',
    keywords: 'communication',
  },
  CRM: {
    label: 'CRM',
    keywords: 'crm',
  },
  ENRICHMENT: {
    label: 'Enrichment',
    keywords: 'encrichment',
  },
  KNOWLEDGE_BASE: {
    label: 'Knowledge base',
    keywords: 'knowledgebase',
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/ListConstants.js